import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Col } from "antd";

import Detail from "./detail";
import colors from "../../colors";
import CustomIcon from "../app/generic/customIcon";
import { getEntities } from "../../modules/crudOperations";

const Notifications = () => {
  const intl = useIntl();
  const { data } = useSelector((state) => state.language);
  const { authenticated } = useSelector((state) => state.session);

  const [notifications, setNotifications] = useState();
  const handleLoadNotifications = useCallback(() => {
    authenticated && getEntities("notification", setNotifications);
  }, [authenticated]);

  const handleIconClick = useCallback(() => {
    setNotifications([
      ...notifications.map((n) => ({ ...n, read: n.read ? true : undefined })),
    ]);
  }, [notifications]);

  useEffect(() => {
    handleLoadNotifications();
  }, [handleLoadNotifications]);

  const [showIcon, setShowIcon] = useState();
  const [notification, setNotification] = useState();
  useEffect(() => {
    setNotification(
      notifications &&
        notifications !== "e" &&
        notifications.some((n) => n.read === undefined)
        ? notifications.find((n) => n.read === undefined)
        : undefined
    );
    setShowIcon(
      notifications &&
        notifications !== "e" &&
        notifications.some((n) => !n.read)
    );
  }, [notifications]);

  return (
    <>
      {authenticated && notification && (
        <Detail
          language={data}
          notification={notification}
          notifications={notifications}
          onSetNotifications={setNotifications}
        />
      )}
      {authenticated && showIcon && (
        <Col className="notification-container">
          <CustomIcon
            fontSize={30}
            color={colors.RED}
            type="notification"
            onClick={handleIconClick}
            title={intl.formatMessage({
              id: "notification.read",
              defaultMessage: "kliknutím zobrazíte nepřečtené notifikace",
            })}
          />
        </Col>
      )}
    </>
  );
};

export default Notifications;
